module.exports = __webpack_public_path__ + "img/lightning.4c21324.png";